import bval from './bval'
import validate from './validate'

export { bval, validate }

export default {
  bval,
  validate,
}
